module.exports = __webpack_public_path__ + "7b983e01529953c7241b99ac5e4fa759.pdf";